import fetch from 'isomorphic-fetch'
import moment from 'moment'
import publicIp from 'public-ip'
import { FormField, FormFieldType, FormFieldValue, IndexableAssocObject } from '../types'
import {API_URL} from "../config";

export const sanitizeValue = (value:any, validationType: FormFieldType) => {
  if (value == null || validationType == null) {
    return null
  }
  switch (validationType.toLowerCase()) {
    case 'integer':
      let stringValue = value + ''
      return parseInt(stringValue.replace(/\D/g, ''), 10)
    case 'dateTime':
      return value.utc()
    default:
      return value
  }
}

export const generateFormFieldValuesArray = async (fields:FormField[], values:IndexableAssocObject) => {
  let formFieldValues: FormFieldValue[] = []
  await Promise.all(fields.map((field) => {
    return new Promise(resolve => {
      if (field.formFieldId == null) {
        return resolve()
      }
      const validationType = (field.validationType != null) ? field.validationType : field.type
      const value : FormFieldValue = {
        value: sanitizeValue(values[field.name], validationType),
        valueType: field.type,
        formFieldId: field.formFieldId,
        formSubmissionId: null
      }
      if (value.value != null) {
        formFieldValues.push(value)
      }
      return resolve()
    })
  }))
  return formFieldValues
}

export const postFormSubmission = async (formId:number, values:FormFieldValue[]) => {
  const ipAddress = await publicIp.v4()
  try {
    let response = await fetch(`${API_URL}form-submissions`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        formId: formId,
        dateSubmitted: moment.utc(),
        agent: navigator.userAgent,
        ipAddress: ipAddress,
        values: values
      })
    })
    return response.json()
  } catch (error) {
    throw new Error(error)
  }
}

export const getStores = async () => {
  try {
    let response = await fetch(`${API_URL}stores`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    return response.json()
  } catch (error) {
    return new Error(error)
  }
}
